import { MIP_MANAGE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { mipManagePath } from '@dealstack/frontend/app/pages/Routing/routes.utils';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { SummaryDealMip } from '@dealstack/shared/lib/generated';
import { useMemo } from 'react';
import { AddBreadcrumbItem } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.types';

interface Props {
	view: 'home';
	dealId?: string;
	currentMip?: SummaryDealMip;
}

export const generateKycBreadcrumbs = (
	props: Props,
	tMipManage: ReturnType<typeof useTranslationMipManage>
): AddBreadcrumbItem[] => {
	switch (props.view) {
		case 'home': {
			const mipKycUrl = mipManagePath(MIP_MANAGE_ROUTES.KYC, {
				mipId: props?.currentMip?.id ?? '',
				dealId: props.dealId ?? '',
			});

			const suffixBreadcrumb = {
				name: tMipManage('tabs.kyc'),
				url: mipKycUrl,
				hideInAppHeader: true,
			};
			const mipUrl = mipManagePath(MIP_MANAGE_ROUTES.INVESTORS, {
				mipId: props?.currentMip?.id ?? '',
				dealId: props.dealId ?? '',
			});

			const mipBreadcrumb = {
				name: props?.currentMip?.programmeName ?? '',
				url: `${mipUrl}`,
				hideInAppHeader: true,
			};
			const kycDetailsBreadcrumb = {
				name: tMipManage('kyc.breadcrumbs.kyc_details'),
				url: '',
				noLink: true,
				hideInAppHeader: true,
			};
			return [mipBreadcrumb, suffixBreadcrumb, kycDetailsBreadcrumb];
		}

		default:
			return [];
	}
};

export function useKycBreadcrumbs(props: Props) {
	const tMipManage = useTranslationMipManage();

	const breadcrumbs = useMemo(() => {
		return generateKycBreadcrumbs(props, tMipManage);
	}, [props, tMipManage]);

	useBreadcrumbs(breadcrumbs);
}
